import { Trash2, Download } from 'lucide-react';
import { Button } from 'common/components';
import styles from './BulkActions.module.scss';

export interface BulkActionsHandlerParams {
    selectedCallId?: string;
}

export interface BulkActionsProps {
    selectedCalls: string[];
    handleDeleteCalls: (params: BulkActionsHandlerParams) => void;
    handleExportCSV: (params: BulkActionsHandlerParams) => void;
}

export const BulkActions = ({ selectedCalls, handleDeleteCalls, handleExportCSV }: BulkActionsProps) => {
    return (
        <div className={styles.workflowLeadsActions}>
            <span>Selected {selectedCalls.length}</span>
            <div className={styles.buttonsContainer}>
                <Button
                    variant='primary'
                    size='sm'
                    icon={Trash2}
                    iconOnly
                    disabled={!selectedCalls.length}
                    onClick={() => handleDeleteCalls({})}
                />
                <Button
                    variant='primary'
                    size='sm'
                    icon={Download}
                    iconOnly
                    disabled={!selectedCalls.length}
                    onClick={() => handleExportCSV({})}
                />
            </div>
        </div>
    );
};
